import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { isTenantAuthenticated, subscribeAuth } from "../lib/auth";

export function TenantAuthGate() {
  const [authed, setAuthed] = useState(() => isTenantAuthenticated());
  const params = useParams<{ facility: string }>();
  const location = useLocation();

  useEffect(() => subscribeAuth(() => setAuthed(isTenantAuthenticated())), []);

  if (!authed) {
    const facility = params.facility;
    // The unauthenticated portal sign-in screen lives at /:facility
    // (e.g. portal.nestplot.com/elie5) — there is no /portal/.../login
    // route. Falling back to "/" lets the tenant pick / enter their
    // facility if the param is missing.
    const target = facility
      ? `/${facility}?next=${encodeURIComponent(location.pathname)}`
      : `/?next=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
